import * as React from 'react';
import { Skeleton } from 'shared/containers/NewbuildingOffersCarouselContainer/components/Skeleton';

import * as styles from './styles.css';

export const NewbuildingOffersSkeleton: React.FC = () => {
  return (
    <>
      {Array.from({ length: 5 }, (_, index) => (
        <div key={index} className={styles['skeleton-item']}>
          <Skeleton />
        </div>
      ))}
    </>
  );
};
